module.exports = __webpack_public_path__ + "static/img/15.1cb9aa88.png";